import {callApi} from '@/lib/api/callApi';

/**
 * 取得使用者證書列表
 * @param {Object} params 要篩選的資料
 * @param {Integer} offset 要篩選的資料
 * @param {Integer} limit 要篩選的資料
 * @param {String} [id] 要篩選的資料
 * @param {String} [userId] 要篩選的資料
 * @param {String} [identificationNo] 要篩選的資料
 * @param {String} [name] 要篩選的資料
 * @param {String} [tournamentGroupId] 要篩選的資料
 * @param {String} [paymentId] 要篩選的資料
 * @param {Boolean} [isApplied] 要篩選的資料
 * @param {Boolean} [isNeedExported] 要篩選的資料
 * @returns {Promise} promise
 */
async function getCertifications(params) {
  const res = await callApi({
    category: 'certification',
    apiName: '',
    method: 'get',
    params,
    defaultError: '載入證書失敗',
  });
  return res.data;
}

/**
 * 取得單一證書
 * @param {String} id 證書id
 * @returns {Promise} promise
 */
async function getCertificationById(id) {
  const res = await callApi({
    category: 'certification',
    apiName: `${id}`,
    method: 'get',
    defaultError: '載入證書失敗',
  });
  return res.data;
}

/**
 * 申請證書
 * @param {Object} params 要送出的資料
 * @param {String} params.id 資料
 * @param {String} params.recipient 資料
 * @param {String} params.recipientMobile 資料
 * @param {Number} params.recipientDistrictId 資料
 * @param {String} params.recipientAddress 資料
 * @param {String} params.platform 資料
 * @param {String} params.parameter 資料
 * @param {String} params.type 資料
 * @returns {Promise} promise
 */
async function paymentCertificationById(params) {
  const data = {
    recipient: params.recipient,
    recipientMobile: params.recipientMobile,
    recipientCityId: params.recipientCityId,
    recipientAddress: params.recipientAddress,
    platform: params.platform,
    parameter: params.parameter,
    englishName: params.englishName,
    type: params.type,
  };
  const res = await callApi({
    category: 'certification',
    apiName: `${params.id}/payment`,
    method: 'post',
    data,
    defaultError: '申請證書失敗',
  });
  return res.data;
}

export default {
  getCertifications,
  getCertificationById,
  paymentCertificationById,
};
